import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Button, Card, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { cookiesKeyNames } from "@revbox/common-fe";
import { getPubAbbr } from "@revbox/helpers-fe";
import { getMe, login } from "../services/micro";
import { setUser } from "../features/user";
import { logosModule } from "../modules/logos";
import { useCookiesContext } from "../contexts/CookiesContext";
import { decrypt } from "../helpers/crypto";
import { useRedirectsContext } from "../contexts/RedirectsContext";

function getPublisherId() {
  const urlParams = new URLSearchParams(window.location.search);
  const urlDomain = window.location.hostname;

  if (urlDomain === "ppc.hoteltechreport.com") {
    return 67;
  }

  if (urlDomain === "app.netnetix.com") {
    return 34;
  }

  if (urlDomain === "stage.netnetix.com") {
    return 34;
  }

  return urlParams.get("pub") || 34;
}

export const Signin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [siteLogo, setSiteLogo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [publisherId, setPublisherId] = useState(null);
  const urlParams = new URLSearchParams(window.location.search)
  const advIdParam = urlParams.get('advId')
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { updateCookiesProperty, removeCookiesProperty, cookiesData } =
    useCookiesContext();

  const {
    openAdvHomePage
  } = useRedirectsContext();

  // useEffect(() => {
  //   const publisher_id = getPublisherId();

  //   if (!publisher_id) {
  //     const publisherIdFromCookies =
  //       cookiesData["pub"]?.[cookiesKeyNames.publisherId];
  //     if (publisherIdFromCookies) {
  //       navigate("/pages/signin?pub=" + publisherIdFromCookies + (advIdParam ? "&advId=" + advIdParam : ""))
  //     }
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [cookiesData]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      toast.error("Please enter your email and password.");
      return;
    }

    login(email, password)
      .then((res) => {
        if (res?.success) {
          toast.success("Login successful. Redirecting...");
          
          setLoading(true)

          dispatch(setUser(res.data));
          if (res.data.default_theme === "dark") {
            updateCookiesProperty(cookiesKeyNames.skinMode, "dark");
          }
          if(advIdParam) {
            const decrypted_adv_id = decrypt(advIdParam);
            
            if (!cookiesData[decrypted_adv_id]?.[cookiesKeyNames.language]) {
              updateCookiesProperty(cookiesKeyNames.token, res.data.token, decrypted_adv_id);
              updateCookiesProperty(cookiesKeyNames.language, res.data.language, decrypted_adv_id)
              updateCookiesProperty(cookiesKeyNames.tourAdvInit, res.data.tour_adv_init, decrypted_adv_id)
              updateCookiesProperty(cookiesKeyNames.tourAdvBidding, res.data.tour_adv_bidding, decrypted_adv_id)
              updateCookiesProperty(cookiesKeyNames.email, res.data.email, decrypted_adv_id)
            }
          } else {
            if (!cookiesData["pub"]?.[cookiesKeyNames.language]) {
              updateCookiesProperty(cookiesKeyNames.language, res.data.language);
              updateCookiesProperty(cookiesKeyNames.tourAdvInit, res.data.tour_adv_init)
              updateCookiesProperty(cookiesKeyNames.tourAdvBidding, res.data.tour_adv_bidding)
              updateCookiesProperty(cookiesKeyNames.email, res.data.email)
            }
          }
          
          updateCookiesProperty(cookiesKeyNames.token, res.data.token);
          updateCookiesProperty(
            cookiesKeyNames.publisherId,
            res.data.publisher_id
          );
          updateCookiesProperty(cookiesKeyNames.showCurrency, null);
          removeCookiesProperty(cookiesKeyNames.currentPeriod);
          removeCookiesProperty(cookiesKeyNames.previousPeriod);

          setPublisherId(res.data.publisher_id);

          if (res.data.role === 'CUSTOMER') {
            openAdvHomePage({
              token: res.data.token,
              publisher_id: res.data.publisher_id,
              campaign_id: res.data.campaign_id
            })
          } else if (
            res.data.role !== "developer" &&
            res.data.role !== "content_manager" &&
            res.data.role !== "sales" &&
            res.data.role !== "accountant" 
          ) {
            const navigateLink =
              "/pub/dashboard/revenue?pub=" + res.data.publisher_id + (advIdParam ? "&advId=" + advIdParam : "");

            window.location.href = navigateLink;
          } else {
            const navigateLink =
              "/pub/inventory/queue?pub=" + res.data.publisher_id + (advIdParam ? "&advId=" + advIdParam : "");

            window.location.href = navigateLink;
          }
        } else {
          toast.error("Login failed.");
        }
      })
      .catch((err) => {
        toast.error("Login failed.");
        console.log("Error", err);
      });
  };

  useEffect(() => {
    const publisherIdByAbbr = getPubAbbr();
    let siteLogo = logosModule(publisherIdByAbbr);
    
    if (!publisherIdByAbbr) {
      const publisherIdFromCookies =
        cookiesData["pub"]?.[cookiesKeyNames.publisherId];

      siteLogo = logosModule(publisherIdFromCookies);
    }

    setSiteLogo(siteLogo);
    setPublisherId(publisherIdByAbbr);
  }, [cookiesData, publisherId]);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const token = searchParams.get("token");

    if (!token) {
      return;
    }

    const login = async () => {
      const res = await getMe(token);
      if (res.success) {
        toast.success("Login successful. Redirecting...");
        dispatch(setUser(res.data));

        if (res.data.default_theme === "dark") {
          updateCookiesProperty(cookiesKeyNames.skinMode, "dark");
        }
        updateCookiesProperty(cookiesKeyNames.token, res.data.token);
        updateCookiesProperty(
          cookiesKeyNames.publisherId,
          res.data.publisher_id
        );
        removeCookiesProperty(cookiesKeyNames.currentPeriod);
        removeCookiesProperty(cookiesKeyNames.previousPeriod);

        if (
          res.data.role !== "developer" &&
          res.data.role !== "content_manager" &&
          res.data.role !== "sales"
        ) {
          // const navigateLink = isIOSOrSafari() ? "/pub/dashboard/revenue?refresh=true&token=" + res.data.token : "/pub/dashboard/revenue?refresh=true"
          // const navigateLink = "/pub/dashboard/revenue?refresh=true"
          const navigateLink =
            "/pub/dashboard/revenue?pub=" + res.data.publisher_id + (advIdParam ? "&advId=" + advIdParam : "");

          window.location.href = navigateLink;
          // navigate(navigateLink);
        } else {
          // const navigateLink = isIOSOrSafari() ? "/pub/inventory/queue?refresh=true&token=" + res.data.token : "/pub/inventory/queue?refresh=true"
          const navigateLink =
            "/pub/inventory/queue?pub=" + res.data.publisher_id + (advIdParam ? "&advId=" + advIdParam : "");

          window.location.href = navigateLink;
          //navigate(navigateLink);
        }
      } else {
        toast.error("Login failed.");
      }
    };

    login();
  }, []);

  if (loading && publisherId) {
    return (
      <></>
    );
  }

  return (
    <div className="page-sign stripes-bg">
      <Card className="card-sign">
        <Card.Header className="pb-3">
          <Link to="/" className="header-logo">
            {siteLogo}
          </Link>
          <Card.Title>Sign In</Card.Title>
          <Card.Text>Welcome back! Please sign in to continue.</Card.Text>
        </Card.Header>
        <Card.Body className="pb-4 pt-3">
          <Form onSubmit={handleSubmit}>
            <div className="mb-4">
              <Form.Label>Email address</Form.Label>
              <Form.Control
                onChange={(e) => setEmail(e.target.value)}
                value={email}
                autoComplete="email"
                autoFocus
                type="email"
                placeholder="Enter your email address"
              />
            </div>
            <div className="mb-4">
              <Form.Label className="d-flex justify-content-between">
                Password <Link to={`/forgot-password?pub=${publisherId}`}>Forgot password?</Link>
              </Form.Label>
              <Form.Control
                onChange={(e) => setPassword(e.target.value)}
                value={password}
                type="password"
                autoComplete="current-password"
                placeholder="Enter your password"
              />
            </div>
            <Button type="submit" variant="primary" className="btn-sign">
              Sign In
            </Button>
            {/* <div className="divider">
              <span>Subject to Terms & Conditions</span>
            </div> */}
                    </Form>
                </Card.Body>
            </Card>
        </div>
    )
}

// eslint-disable-next-line no-lone-blocks
// {
//    /* <Card.Footer className="pt-4">
//   Don't have an account? <Link to="/pages/signup">Create One</Link>.
// </Card.Footer> */
// }
